import { IconButton, Badge, useTheme, useMediaQuery } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';
import { useNotifications } from '../../context/NotificationContext';
import { responsiveIconSize } from '../../util/responsiveUtils';

interface NotificationIconProps {
    onClick: () => void;
    color?: string;
}

export function NotificationIcon({ onClick, color }: NotificationIconProps) {
    const { unreadCount } = useNotifications();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const iconColor = color || (theme.palette.mode === 'dark' ? 'white' : 'text.primary');

    return (
        <IconButton
            onClick={onClick}
            size={isMobile ? "small" : "medium"}
            sx={{
                color: iconColor,
                p: { xs: 0.5, sm: 1 },
                '@media (hover: hover)': {
                    '&:hover': {
                        backgroundColor: theme.palette.mode === 'dark' 
                            ? 'rgba(255, 255, 255, 0.08)' 
                            : 'rgba(0, 0, 0, 0.04)'
                    }
                }
            }}
        >
            <Badge 
                badgeContent={unreadCount} 
                color="error"
                max={99}
                invisible={unreadCount === 0}
            >
                <InboxIcon sx={{ fontSize: responsiveIconSize.sm, color: iconColor }} />
            </Badge>
        </IconButton>
    );
} 